import { render, staticRenderFns } from "./WithdrawalList.vue?vue&type=template&id=6e2ae6af&scoped=true"
import script from "./WithdrawalList.vue?vue&type=script&lang=js"
export * from "./WithdrawalList.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalList.vue?vue&type=style&index=0&id=6e2ae6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2ae6af",
  null
  
)

export default component.exports